var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["modal/modal-close.j2"] = require( "modal/modal-close.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/chat/chat-invitation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/chat/chat-invitation.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("staticUrl")) {
var t_4 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_4);
output += "\n\n<div class=\"c-chat-invitation js-chat-invitation\" id=\"snapins_invite\" role=\"dialog\" aria-labelledby=\"chat-invitation\" tabindex=\"-1\">\n\n    <div class=\"c-chat-invitation__inner\">\n\n        <img class=\"c-chat-invitation__avatar\" src=\"";
output += runtime.suppressValue((lineno = 6, colno = 62, runtime.callWrap(t_4, "staticUrl", context, ["/images/global/icons/icon-logo-avatar.svg"])), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 6, colno = 117, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["site-logo-title"])), env.opts.autoescape);
output += "\" />\n\n        <h2 class=\"c-chat-invitation__h2\">\n            ";
output += runtime.suppressValue((lineno = 9, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["chat-invitation_heading"])), env.opts.autoescape);
output += "\n        </h2>\n\n        <p class=\"c-chat-invitation__p\">\n            ";
output += runtime.suppressValue((lineno = 13, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["chat-invitation_body-copy"])), env.opts.autoescape);
output += "\n        </p>\n\n        <div class=\"o-row o-column o-extra-small--10 o-extra-small--centered\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--6\">\n                <button ";
output += runtime.suppressValue((lineno = 19, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey"),"Chat Rejected",""])), env.opts.autoescape);
output += " type=\"button\" class=\"c-chat-invitation__decline-button js-decline-chat-invite\">\n                    ";
output += runtime.suppressValue((lineno = 20, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["chat-invitation_decline"])), env.opts.autoescape);
output += "\n                </button>\n            </div>\n\n            <div class=\"o-column o-extra-small--12 o-medium--6\">\n                <button ";
output += runtime.suppressValue((lineno = 25, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey"),"Chat Accepted",""])), env.opts.autoescape);
output += " type=\"button\" class=\"c-chat-invitation__accept-button js-accept-chat-invite\">\n                    ";
output += runtime.suppressValue((lineno = 26, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["chat-invitation_accept-cta"])), env.opts.autoescape);
output += "\n                </button>\n            </div>\n\n        </div>\n\n    </div>\n\n    <a class=\"o-modal__close-icon js-decline-chat-invite\" href=\"#\">\n        ";
env.getTemplate("modal/modal-close.j2", false, "core/templates/chat/chat-invitation.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n    </a>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/chat/chat-invitation.j2"] , dependencies)